//////////////////////////////////////////////////////////////////////////////
//
//  Notification Template API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-29
//
//  설명: 알림 템플릿 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 알림 템플릿 관련 API
 */
const NotificationTemplateAPI: ApiGroup = {
    pagedList: {
        title: "알림 템플릿 목록 조회",
        url: "/NotificationTemplate/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 알림 템플릿 목록 조회",
        url: "/NotificationTemplate/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "알림 템플릿 상세 조회",
        url: "/NotificationTemplate/{id}",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "알림 템플릿 등록",
        url: "/NotificationTemplate",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "알림 템플릿 수정",
        url: "/NotificationTemplate/{id}",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "알림 템플릿 삭제",
        url: "/NotificationTemplate/{id}",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
}

export default NotificationTemplateAPI
